import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { Map } from "immutable";
import {
    fetchCreateInvoiceJob,
    clearInvoiceJob,
    fetchUpdateInvoiceJob,
    clearUpdateInvoiceJob,
    fetchInvoiceJob,
    fetchFinalSubmission,
    fetchRemoveInvoice,
    fetchAllInvoiceJob,
    fetchInvoiceCards,
    fetchDealerFromGstin
} from "../actions";
import Icon from "antd/lib/icon";
import JobCreate from "./job-create";
import InvoiceList from "./invoice-list";
import ReviewInvoices from "./review-invoices";
import { STATE_STATUS } from "../constants";

class CompanyInvoices extends Component { 
    state={
        formSelectedSeller : {}
    }
    handleInvoiceForm = (sellers) => {
        this.setState({
            formSelectedSeller : sellers
        });
    }
    goBack = () => {
        if (this.props.canReviewInvoices) {
            return this.props.history.replace("/app/companies/invoices/review");
        }
        return this.props.history.replace("/app/companies/invoices/upload");
    }

    render() {
        return (
            <div>
                <Icon
                    onClick={this.goBack}
                    className={"pt-10 pl-10 cursor-pointer"}
                    type={"arrow-left"}
                    theme="outlined"
                    style={{ fontSize: 24 }}
                />
                <Switch>
                    {this.props.canReviewInvoices ? <Route 
                        exact={true} 
                        path={"/app/companies/invoices/review"} 
                        component={() => <ReviewInvoices
                            jobs={this.props.jobs}
                            jobsStatus={this.props.jobsStatus}
                            jobsCount={this.props.jobsCount}
                            filter={this.props.filter}
                            fetchJobsCount={this.props.fetchJobsCount}
                            fetchJobs={this.props.fetchJobs}
                            history={this.props.history}
                            noDataMessage={this.props.noDataMessage}
                            emailStatus={this.props.emailStatus}
                        />} 
                    /> : null }
                    <Route 
                        exact={true} 
                        path={"/app/companies/invoices/upload"} 
                        component={props => <JobCreate 
                            history={props.history}
                            requests={this.props.requests} 
                            createNewJob={this.props.fetchCreateInvoiceJob} 
                            getDealers={this.props.fetchDealerFromGstin}
                            dealers ={this.props.dealers}
                            handleInvoiceForm={this.handleInvoiceForm}
                            formSelectedSeller={this.state.formSelectedSeller}
                        />} 
                    />
                    <Route 
                        exact={true} 
                        path={"/app/companies/invoices/:jobId"} 
                        component={props => {
                            const job = this.props.jobs.get(Number(props.match.params.jobId));
                            if(!job) {
                                this.props.history.replace("/app/companies/invoices/upload");
                                return null;
                            }
                            return (
                                <InvoiceList
                                    jobId={job.id}
                                    isEditable={job.isJobEditable(this.props.canReviewInvoices)}
                                    invoicesStatus={job.invoicesStatus}
                                    invoices={job.invoices}
                                    fetchInvoices={this.props.fetchInvoiceJob}
                                    updateInvoices={this.props.updateInvoices}
                                    removeInvoice={this.props.removeInvoice}
                                    isChecker={this.props.canReviewInvoices}
                                    dealers ={this.props.dealers}
                                    history={this.props.history}
                                />
                            );
                        }} 
                    />
                </Switch>
            </div>
        );
    }
}

CompanyInvoices.propTypes = {
    requests: PropTypes.object,
    jobs: PropTypes.object,
    jobsCount: PropTypes.object,
    jobsStatus: PropTypes.string,
    filter: PropTypes.object,
    fetchJobs: PropTypes.func,
    fetchJobsCount: PropTypes.func,
    fetchCreateInvoiceJob: PropTypes.func,
    updateInvoices: PropTypes.func,
    removeInvoice: PropTypes.func,
    invoiceJob: PropTypes.object,
    clearInvoiceJob: PropTypes.func,
    fetchUpdateInvoiceJob: PropTypes.func,
    updateInvoiceJob: PropTypes.object,
    clearUpdateInvoiceJob: PropTypes.func,
    location: PropTypes.object,
    fetchInvoiceJob: PropTypes.func,
    history: history.object,
    fetchFinalSubmission: PropTypes.func,
    
    canReviewInvoices: PropTypes.bool,
    canDisburseInvoices: PropTypes.bool,
    fetchDealerFromGstin : PropTypes.func,
    dealers : PropTypes.object,
    emailStatus : PropTypes.string,
};


const mapStateToProps = state => {
    return {
        canReviewInvoices: state.user.getIn(["permissions", "page_review_invoices"]),
        canDisburseInvoices: state.user.getIn(["permissions", "page_invoice_for_disbursal"]),
        requests: state.invoiceJobs.get("requests", Map({})),
        jobs: state.invoiceJobs.get("jobs", Map({})),
        noDataMessage: state.invoiceJobs.get("noDataMessage") || "",
        jobsStatus: state.invoiceJobs.get("jobsStatus", STATE_STATUS.UNFETCHED),
        emailStatus: state.invoiceJobs.get("emailStatus", STATE_STATUS.UNFETCHED),
        jobsCount: state.invoiceJobs.get("jobsCount", Map({})),
        filter: state.invoiceJobs.get("filter"),
        dealers : state.invoiceJobs.get("dealers" , Map({}))
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchCreateInvoiceJob,
            clearInvoiceJob,
            clearUpdateInvoiceJob,
            fetchInvoiceJob,
            fetchFinalSubmission,
            removeInvoice: fetchRemoveInvoice,
            updateInvoices: fetchUpdateInvoiceJob,
            fetchJobs: fetchAllInvoiceJob,
            fetchJobsCount: fetchInvoiceCards,
            fetchDealerFromGstin
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CompanyInvoices);

